import { render, staticRenderFns } from "./NumeroOpcional.vue?vue&type=template&id=3d1c1bc7&"
import script from "./NumeroOpcional.vue?vue&type=script&lang=js&"
export * from "./NumeroOpcional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports